module.exports = __webpack_public_path__ + "img/LeftShadow.c2ea49d6.png";